import { render, staticRenderFns } from "./dekt_details.vue?vue&type=template&id=0fbe1ef6&scoped=true&"
import script from "./dekt_details.vue?vue&type=script&lang=js&"
export * from "./dekt_details.vue?vue&type=script&lang=js&"
import style0 from "./dekt_details.vue?vue&type=style&index=0&id=0fbe1ef6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbe1ef6",
  null
  
)

export default component.exports